import useProducts from '@hooks/product/useProducts';
import { cTAClicked } from '@repo/ui/src/services/analytics';
import { ModalID, useModal } from '@repo/ui/src/modules/UI';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import Product from '@models/product';

interface ShoppableIngredientProps {
  product: Product;
}

const ShoppableIngredient = ({ product }: ShoppableIngredientProps) => {
  const { products, isLoading } = useProducts([product]);
  const [shoppableProduct] = products;
  const { push } = useModal(ModalID.learnMore);

  // If product failed to load or doesn't have shop data, render as plain text
  if (!shoppableProduct?.shop && !isLoading) {
    return <span className="tra-text-web-body-l mb-0 pl-2">{product?.title || 'Product'}</span>;
  }

  // If still loading, show loading state
  if (isLoading) {
    return <span className="tra-text-web-body-l mb-0 pl-2">{product?.title || 'Loading...'}</span>;
  }

  return (
    <span className="tra-text-web-body-l mb-0 pl-2">
      <Button
        variant={ButtonVariant.bare}
        size="none"
        className="text-brand-300 underline hover:underline normal-case tra-text-web-body-l"
        onClick={() => {
          if (shoppableProduct) {
            push(shoppableProduct);
            cTAClicked({ cta_text: shoppableProduct.title });
          }
        }}
      >
        {shoppableProduct?.title}
      </Button>
    </span>
  );
};

export default ShoppableIngredient;
